import { useState, useEffect, useCallback } from 'react';
import { supabase } from '@/lib/supabase';
import { useFamily } from '@/context/FamilyContext';
import type { Item, ItemType } from '@/types';

export function useItems(filterType?: ItemType) {
  const { family } = useFamily();
  const [items, setItems] = useState<Item[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    if (!family) { setItems([]); setLoading(false); return; }
    setLoading(true);
    let q = supabase.from('items').select('*').eq('family_id', family.id).order('created_at', { ascending: false });
    if (filterType) q = q.eq('type', filterType);
    const { data, error } = await q;
    if (error) setError(error.message);
    else setItems(data as Item[]);
    setLoading(false);
  }, [family, filterType]);

  useEffect(() => { load(); }, [load]);

  return { items, loading, error, reload: load };
}

export function useItem(id: string) {
  const [item, setItem] = useState<Item | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase.from('items').select('*').eq('id', id).maybeSingle()
      .then(({ data }) => { setItem(data as Item | null); setLoading(false); });
  }, [id]);

  return { item, loading };
}
